import { render, staticRenderFns } from "./FixesFirst.vue?vue&type=template&id=5dfda993&scoped=true&"
import script from "./FixesFirst.vue?vue&type=script&lang=js&"
export * from "./FixesFirst.vue?vue&type=script&lang=js&"
import style0 from "./FixesFirst.vue?vue&type=style&index=0&id=5dfda993&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfda993",
  null
  
)

export default component.exports